
<workflow-no-access [workflowTargetInfo]="workflowTargetInfo"></workflow-no-access>
<div class="container">
  <div class="row mt-2">
    <div class="col-12">
      <error [error]="error"></error>
    </div>
  </div>
  <div class="row mt-2" *ngIf="warningMessage">
    <div class="col-12">
      <div class="alert alert-warning"><span>{{ warningMessage }}</span></div>
    </div>
  </div>
  <div class="row step-description-block">
    <div class="col">
      <div class="float-left">
        <p>Setup Project Groups</p>
      </div>
    </div>
  </div>
  <div class="row" *ngIf="projectHasCustomer">
    <div class="col table-card">
      <list-controls [pageName]="'AreaGroups'" [search]="searchText" [limit]="pageSize" [page]="currentPage" [numPages]="maxPages" [totalCount]="filteredGroups.length" (onChange)="onListControlsChange($event)">
        <div class="btn-group float-right">
          <button class="btn btn-outline-secondary" id="importITSMGroupButton" [disabled]="!itsmGroupsImportableCount || !workflowTargetInfo.correctRole" type="button" (click)="addITSMGroup()">Import ITSM Group</button>
          <button class="btn btn-outline-secondary" id="addRowButton" [disabled]="!workflowTargetInfo.correctRole" type="button" (click)="addAreaGroup()">Add Row</button>
        </div>
      </list-controls>
      <fieldset [disabled]="!workflowTargetInfo.correctRole">
        <table class="table table-striped">
          <thead>
            <tr>
              <th class="required">Area</th>
              <th>Group</th>
              <th>Consumable</th>
              <th>Longlife</th>
              <th>Maintenance</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let g of displayedGroups; let i = index">
              <td>
                <input class="form-control" id="areaName{{i}}" type="text" [(ngModel)]="g.areaName" maxlength="75" [disabled]="!g.allowEdit" (change)="changed(g)" *ngIf="!g.areaDisabled">
                <input class="form-control" id="areaNameDisabled{{i}}" type="text" [(ngModel)]="g.areaName" maxlength="75" [disabled]="!g.allowEdit" (change)="changed(g)" style="background: #FFCCCC;" *ngIf="g.areaDisabled"><span class="d-block" *ngIf="g.differsFromITSM" style="color: red;">Differs from ITSM</span><span class="d-block" *ngIf="g.areaNameRequired" style="color: red;">Area is required</span><span class="d-block" *ngIf="g.areaDisabled" style="color: red;">Area is disabled in ITSM</span>
              </td>
              <td>
                <input class="form-control" id="groupName{{i}}" type="text" [(ngModel)]="g.groupName" maxlength="75" [disabled]="!g.allowEdit" (change)="changed(g)" *ngIf="!g.areaDisabled &amp;&amp; !g.groupDisabled">
                <input class="form-control" id="groupNameDisabled{{i}}" type="text" [(ngModel)]="g.groupName" maxlength="75" [disabled]="!g.allowEdit" (change)="changed(g)" style="background: #FFCCCC;" *ngIf="g.areaDisabled || g.groupDisabled"><span class="d-block" *ngIf="g.groupNameRequired" style="color: red;">Group is required</span><span class="d-block" *ngIf="g.groupDisabled &amp;&amp; !g.areaDisabled" style="color: red;">Group is disabled in this area</span><span class="d-block" *ngIf="g.duplicate" style="color: red;">Duplicate group entry</span><span class="d-block" *ngIf="g.duplicateGroup &amp;&amp; !g.duplicate" style="color: red;">Duplicate group entry</span><span class="d-block" *ngIf="g.itsmDuplicate" style="color: red;">Duplicate group in ITSM</span><span class="d-block" *ngIf="g.disableEditReasons" style="color: red;">Editing is disabled 
                  <button class="btn btn-primary btn-circle-sm oi oi-question-mark" (click)="showAsmDisableReason(g, 'groupDisable')"></button></span>
                <div *ngIf="g.asmCheckedDate">
                  <label class="mb-0 mt-3">Earliest ASM Date</label>
                  <input class="form-control" type="text" [(ngModel)]="g.asmCheckedDate" disabled>
                </div>
              </td>
              <td>
                <div class="form-check">
                  <input class="form-check-input" id="consumableCheckbox" [disabled]="!!g.disableEditReasons" type="checkbox" [(ngModel)]="g.itsmConsumableAutoFulfillment" (change)="itsmComsumableChanged(g)" autoLinkToLabel>
                  <label class="form-check-label">ASM</label>
                </div>
              </td>
              <td>
                <div class="form-check">
                  <input class="form-check-input" id="longlifeCheckbox" [disabled]="!!g.disableEditReasons" type="checkbox" [(ngModel)]="g.itsmLongLifeConsumableAutoFulfillment" (change)="itsmLonglifeChanged(g)" autoLinkToLabel>
                  <label class="form-check-label">ASM</label>
                </div>
              </td>
              <td>
                <div class="form-check">
                  <input class="form-check-input" id="maintenanceCheckbox" [disabled]="!!g.disableEditReasons" type="checkbox" [(ngModel)]="g.doMaintenanceAutoOrder" (change)="itsmMaintenanceChanged(g)" autoLinkToLabel>
                  <label class="form-check-label">ASM</label>
                </div>
              </td>
              <td>
                <button class="btn btn-outline-danger oi oi-trash" id="removeAreaGroupButton" *ngIf="!g.assetsRelated" type="button" (click)="removeAreaGroup(g)"></button><span *ngIf="g.assetsRelated">Assets Related</span>
              </td>
            </tr>
          </tbody>
        </table>
      </fieldset>
    </div>
  </div>
</div>